module.exports = __webpack_public_path__ + "img/chatbot_slack.26cf12c0.jpg";